import { Flex } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { NotificationCounter } from '@televet/kibble-ui/build/components/NotificationCounter';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React from 'react';

interface TeletriageConversationCenterTriggerProps {
  onClick: () => void;
  unreadMessagesCount: number;
}

export const TeletriageConversationCenterTrigger = ({
  onClick,
  unreadMessagesCount,
}: TeletriageConversationCenterTriggerProps): JSX.Element => {
  return (
    <Button
      className="TeletriageConversationCenter__Trigger"
      variant={unreadMessagesCount > 0 ? 'primary' : 'secondarySubtle'}
      boxShadow="baseR"
      iconName="chevronUp"
      iconPosition="right"
      justifyContent="space-between"
      isFullWidth
      borderTopRadius="lg"
      borderBottomRadius={0}
      onClick={onClick}
      zIndex="overlay"
    >
      <Flex alignItems="center">
        <Text as="p" color="inherit" mr={2}>
          Teletriage
        </Text>
        {unreadMessagesCount > 0 && <NotificationCounter count={unreadMessagesCount} />}
      </Flex>
    </Button>
  );
};
